import { maxPlatform } from "./maxPlatform";

/**
 * Host roles for dual-channel deploy:
 * - PWA / QR gateway → PUBLIC_WEB_URL (e.g. mvk.dev.tezam.by)
 * - MAX mini-app URL in platform.max.ru → MAX host (e.g. mvk-max.dev.tezam.by)
 */

export function getHostname(): string {
  if (typeof window === "undefined") return "";
  return window.location.hostname.toLowerCase();
}

/** Host registered as MAX mini-app (not for PWA install / printed QR). */
export function isMaxMiniAppHost(hostname = getHostname()): boolean {
  if (!hostname) return false;
  return (
    hostname.startsWith("mvk-max.") ||
    hostname.startsWith("max.") ||
    hostname.includes(".max.")
  );
}

/** Admin portal host. */
export function isAdminHost(hostname = getHostname()): boolean {
  return hostname.includes("mvk-admin") || (hostname.includes("admin.") && !hostname.includes("mvk-max"));
}

/**
 * Enable service worker + install banner only on the public PWA host,
 * never inside MAX WebApp and never on the dedicated max.* host.
 */
export function shouldEnableBrowserPwa(): boolean {
  if (typeof window === "undefined") return false;
  if (maxPlatform.isAvailable()) return false;
  if (isMaxMiniAppHost()) return false;
  if (isAdminHost()) return false;
  return true;
}
